import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const AppleIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescWell">apple</desc>
      <circle className="accent" cx="127.5" cy="127.5" r="127.5" />
      <path
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
        d="M127.5 0a127.5 127.5 0 1 0 0 255 127.5 127.5 0 0 0 0-255zm17.7 56.8a41.2 41.2 0 0 1 34.3-14.5c5.6.4 7.2 2.4 4 7.5-7.7 12.2-17.8 20.3-33.2 20.2-3.6-.7-8.8 1.6-10.7-2.6-2.2-4.8 2.9-7.6 5.6-10.6zm-16.1-29.5c11.5-.9 13.7 1.3 11.1 12.7-2.1 9.7-4.5 19.4-6.5 29.1-.9 4.3-3 6.5-7.5 6.1-4.4-.4-5.1-3.7-5.2-7.2-.2-5.6 0-11.3 0-16.9V36.2c-.2-5.6 2.2-8.4 8.1-8.9zM191 202a57.5 57.5 0 0 1-50.4 25.4h-15.3c-49.5 5.2-71.6-30-80.6-70.4a152.5 152.5 0 0 1-2.1-43.7C44.1 93 58.8 80.2 80.9 78.7c12.8-.9 25.2 1.1 37.4 4.5a34.6 34.6 0 0 0 18.6-.1c11.6-3.1 23.3-5.1 35.4-4.5 22.9 1.2 36.4 11.8 39.4 34.4 4.3 32-2.2 62.2-20.7 89z"
      />
      <path
        className="accent"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
        d="M76.6 99.6c-4 .4-6.4 3.2-8.7 6-9.2 11.2-9 24.5-8.3 37.8a73.2 73.2 0 0 0 10.6 35.8c1.8 2.8 4 6.1 7.9 4.2 4-2 2.5-5.6 1.2-8.7-.6-1.5-1.7-2.9-2.3-4.4-7.8-21.2-14.2-42.4 2.6-62.7 2.9-3.5 2.1-6.7-3-8z"
      />
    </Icon>
  );
};

export default AppleIcon;
